var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.854,
    height: 18.132,
    viewBox: "0 0 15.854 18.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16671",
    "data-name": "Rectangle 16671",
    width: 15.853,
    height: 18.132,
    fill: "#1ebcc2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16668",
    "data-name": "Group 16668",
    transform: "translate(4750.446 571.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16050",
    "data-name": "Group 16050",
    transform: "translate(-4750.446 -571.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16049",
    "data-name": "Group 16049",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41407",
    "data-name": "Path 41407",
    d: "M12.517,64.179A4.628,4.628,0,0,0,11.2,60.858a1.684,1.684,0,0,1-.517-1.166,1.665,1.665,0,0,1,2.854-1.218,7.807,7.807,0,0,1,2.03,3.492A7.925,7.925,0,1,1,.151,65.591a7.761,7.761,0,0,1,2.124-7.078A1.666,1.666,0,1,1,4.694,60.8a4.71,4.71,0,0,0-1.311,2.627,4.586,4.586,0,0,0,9.059,1.426c.048-.26.058-.527.074-.679",
    transform: "translate(0 -53.867)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41408",
    "data-name": "Path 41408",
    d: "M88.379,5.083c0-1.144-.007-2.289,0-3.433a1.663,1.663,0,0,1,3.325-.059q.016,3.486,0,6.972a1.663,1.663,0,0,1-3.323-.012c-.012-1.156,0-2.312,0-3.469Z",
    transform: "translate(-82.119 0)",
    fill: "#1ebcc2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.8017975e70769ab1a26267640a8a15cb.svg";
export { ForwardRef as ReactComponent };